import { FaExclamation } from 'react-icons/fa6';
import {
  WiCloud,
  WiCloudy,
  WiDayCloudy,
  WiDayCloudyHigh,
  WiDayFog,
  WiDayHaze,
  WiDayShowers,
  WiDaySunny,
  WiDaySunnyOvercast,
  WiFlood,
  WiFog,
  WiHail,
  WiHurricane,
  WiNightAltPartlyCloudy,
  WiNightClear,
  WiNightCloudyHigh,
  WiNightPartlyCloudy,
  WiNightShowers,
  WiNightStormShowers,
  WiRain,
  WiRainMix,
  WiSandstorm,
  WiShowers,
  WiSleet,
  WiSnow,
  WiSnowWind,
  WiSprinkle,
  WiStormShowers,
  WiThunderstorm,
  WiTornado,
} from 'react-icons/wi';

export const DEFAULT_CONDITION_ICON_COMPONENT = FaExclamation;

export const CONDITION_ICON_COMPONENT_BY_ID = Object.freeze({
  1: WiDaySunny,
  2: WiDaySunnyOvercast,
  3: WiDayHaze,
  4: WiDayCloudy,
  5: WiDayCloudyHigh,
  6: WiCloud,
  7: WiCloudy,
  8: WiDayFog,
  9: WiFog,
  10: WiFog,
  11: WiSandstorm,
  12: WiDayFog,
  13: WiNightClear,
  14: WiNightAltPartlyCloudy,
  15: WiNightPartlyCloudy,
  16: WiNightCloudyHigh,
  17: WiCloud,
  18: WiSprinkle,
  19: WiShowers,
  20: WiRain,
  21: WiStormShowers,
  22: WiThunderstorm,
  23: WiThunderstorm,
  24: WiHail,
  25: WiTornado,
  26: WiHurricane,
  27: WiSleet,
  28: WiRainMix,
  29: WiSnow,
  30: WiSnow,
  31: WiSnowWind,
  32: WiFlood,
  33: WiDayShowers,
  34: WiNightShowers,
  35: WiNightStormShowers,
});
